/**
 *
 * StudentworkMixin
 *
 */

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
//import _ from 'lodash';

export const SurveyMixin = {
  name: 'SurveyMixin',

  data: () => {
    return {
      //
    };
  },

  computed: {
    ...mapState('Mixins/Survey', {
      ms_res_makeSurveyNew: 'res_makeSurveyNew',
      ms_res_checkSurveyHasposted: 'res_checkSurveyHasposted',
    }),

    ...mapGetters('Mixins/Survey', {
      mg_survey: 'survey',
      mg_isSurveyReady: 'isSurveyReady',
    }),

    //
    c_surveyId() {
      //return -1;
    },

    //
    c_isSubmitDisabled() {
      //return false;
    },
  },

  methods: {
    ...mapMutations('Mixins/Survey', {
      mm_RESET_SURVEY_ITEM: 'RESET_SURVEY_ITEM',
    }),

    ...mapActions('Mixins/Survey', {
      ma_getSurvey: 'getSurvey',
      ma_makeSurveyNew: 'makeSurveyNew',
      ma_makeEsgSurveyNew: 'makeEsgSurveyNew',
      ma_checkSurveyHasposted: 'checkSurveyHasposted',
    }),

    getSurvey() {
      this.ma_getSurvey({
        surveyId: this.c_surveyId,
      });
    },

    async doMakeSurveyNew() {
      if (this.$refs.SurveyForm) {
        const formData = new FormData(this.$refs.SurveyForm);
        formData.append('surveyId', this.c_surveyId);
        let payload = {};
        for (const [k, v] of formData) {
          payload = {
            ...payload,
            [k]: v,
          };
        }
        for (let i = 0; i < this.mg_survey.itemList.length; i++) {
          const surveyItemKey = this.mg_survey.itemList[i].surveyItemKey;
          if (!(surveyItemKey in payload)) {
            payload = {
              ...payload,
              [surveyItemKey]: null,
            };
          }
        }
        await this.ma_makeSurveyNew(payload);
      }
    },

    async doAfterMakeSurveyNew() {
      //
    },

    async afterMakeSurveyNew() {
      await this.doAfterMakeSurveyNew();
      this.mm_RESET_SURVEY_ITEM();
    },

    async makeSurveyNew() {
      await this.doMakeSurveyNew();
      await this.afterMakeSurveyNew();
    },
  },
};

export default SurveyMixin;
